import { EnumXFTType } from './enums/enum-xft-type.model';
import { MealTranslation } from './meal-translation.model';

export interface IMeal {
  id?: number;
  sortNumber?: number;
  adultPrice?: number;
  childPrice?: number;
  type?: string;
  xftType?: EnumXFTType;
  accomId?: string;
  accomRoomCategoryId?: string;
  mealTranslations?: MealTranslation[];
}

export class Meal implements IMeal {
  constructor(
    public id?: number,
    public sortNumber?: number,
    public adultPrice?: number,
    public childPrice?: number,
    public type?: string,
    public xftType?: EnumXFTType,
    public mealTranslations?: MealTranslation[]
  ) {}
}
